import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';

const API = (process.env.REACT_APP_API_URL || 'http://localhost:3001') + '/api';
const NAVY = '#0d1b3e';
const GOLD = '#c9a227';

// Shown to Starter customers who existed before the 2026-05-26 pricing
// restructure. Their access to the (previously Starter-bundled) accounting
// suite + consignment + grading workflow is preserved until grandfatheredUntil.
// After that, they need Dealer+ to keep those features. Tells them how long
// they have and links them to upgrade.
export default function GrandfatheredBanner() {
  const [info, setInfo] = useState(null);
  const [dismissed, setDismissed] = useState(() => {
    try { return sessionStorage.getItem('scn-grandfathered-banner-dismissed') === '1'; } catch { return false; }
  });

  useEffect(() => {
    let cancelled = false;
    axios.get(`${API}/stripe/subscription`)
      .then(res => {
        if (cancelled) return;
        const d = res.data;
        if (d.grandfathered && d.grandfatheredUntil) {
          const endsAt = new Date(d.grandfatheredUntil);
          const daysLeft = Math.ceil((endsAt - new Date()) / (24 * 60 * 60 * 1000));
          if (daysLeft > 0) setInfo({ daysLeft, endsAt });
        }
      })
      .catch(() => {});
    return () => { cancelled = true; };
  }, []);

  if (!info || dismissed) return null;

  const dismiss = () => {
    try { sessionStorage.setItem('scn-grandfathered-banner-dismissed', '1'); } catch {}
    setDismissed(true);
  };

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  // Only nag in the last 30 days, earlier it's just noise.
  const urgent = info.daysLeft <= 30;
  const dateStr = info.endsAt.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

  if (isMobile) {
    return (
      <div style={{
        background: urgent ? '#7f1d1d' : NAVY, color: 'white', padding: '8px 12px',
        fontFamily: "'Manrope', sans-serif", fontSize: 12,
        position: 'sticky', top: 0, zIndex: 49,
        display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8,
      }}>
        <span style={{ flex: 1, minWidth: 0, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          <strong style={{ color: GOLD }}>{info.daysLeft}d left</strong>
          <span style={{ color: 'rgba(255,255,255,0.75)', marginLeft: 6 }}>on legacy Starter, Dealer to keep</span>
        </span>
        <Link to="/settings?tab=subscription" style={{ background: GOLD, color: NAVY, textDecoration: 'none', padding: '5px 12px', borderRadius: 6, fontWeight: 800, fontSize: 11, flexShrink: 0 }}>Upgrade</Link>
        <button onClick={dismiss} aria-label="Dismiss" style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.6)', cursor: 'pointer', fontSize: 16, padding: '4px 8px', lineHeight: 1, flexShrink: 0 }}>×</button>
      </div>
    );
  }
  return (
    <div style={{
      background: urgent ? `linear-gradient(135deg, #7f1d1d, ${NAVY})` : `linear-gradient(135deg, ${NAVY}, #1a2e5c)`,
      color: 'white', padding: '8px 18px', fontFamily: "'Manrope', sans-serif", fontSize: 13,
      borderBottom: `1px solid ${GOLD}`, position: 'sticky', top: 0, zIndex: 49,
      display: 'flex', alignItems: 'center', gap: 14, flexWrap: 'wrap',
    }}>
      <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 8 }}>
        <strong style={{ color: GOLD }}>{info.daysLeft} day{info.daysLeft === 1 ? '' : 's'} left</strong>
        <span style={{ color: 'rgba(255,255,255,0.85)' }}>
          on your grandfathered Starter (P&amp;L + grading + consignment lock at Dealer after {dateStr})
        </span>
      </div>
      <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', flex: 1, justifyContent: 'flex-end' }}>
        <Link to="/settings?tab=subscription" style={{ background: GOLD, color: NAVY, textDecoration: 'none', padding: '5px 14px', borderRadius: 6, fontWeight: 800, fontSize: 12 }}>Upgrade to Dealer</Link>
        <button onClick={dismiss} aria-label="Dismiss" style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.5)', cursor: 'pointer', fontSize: 14, padding: '4px 8px', lineHeight: 1 }}>×</button>
      </div>
    </div>
  );
}
